import React from 'react';
import { Ul, SubNav, Li, StyledSubNavLink } from 'features/nav/subNav';

function SubNavBar() {
  return (
    <SubNav>
      <Ul>
        <Li>
          <StyledSubNavLink to="/betting/accounts">
            <div>Accounts</div>
          </StyledSubNavLink>
        </Li>
        <Li>
          <StyledSubNavLink to="/betting/bets">
            <div>Bets</div>
          </StyledSubNavLink>
        </Li>
        <Li>
          <StyledSubNavLink to="/betting/totals">
            <div>Totals</div>
          </StyledSubNavLink>
        </Li>
      </Ul>
    </SubNav>
  );
}

export default SubNavBar;
